import axios from "@/lib/axios";

const getOrderHistory = () => {
  return axios.get("/facility/order_history");
}

export default getOrderHistory;